import { CompetentNLBase, CompetentNLBaseResource } from '../CompetentNL/CompetentNL';

export enum SkillType {
    humanCapability = 'HumanCapability',
    knowledgeArea = 'KnowledgeArea',
}

// TODO: This is needed to transition to CompetentNL skills throughout application
export const fallbackSkillType = SkillType.humanCapability;

export interface SkillBaseResource extends Omit<CompetentNLBaseResource, 'definition'> {
    type: SkillType;
    generatedAtTime?: string;
}

export interface SkillBase extends Omit<CompetentNLBase, 'definition'> {
    type: SkillType;
    generatedAtTime?: Date;
}

export interface HumanCapabilitySkillResource extends SkillBaseResource {
    type: SkillType.humanCapability;
    definition: string;
    altLabels: string[];
    includesScope: string[];
    excludesScope: string[];
}

export interface HumanCapabilitySkill extends SkillBase {
    definition: string;
    altLabels: string[];
    includesScope: string[];
    excludesScope: string[];
}

export interface KnowledgeAreaSkillResource extends SkillBaseResource {
    type: SkillType.knowledgeArea;
    definition: string;
    broadMatch: string;
}

export interface KnowledgeAreaSkill extends SkillBase {
    definition: string;
    broadMatch: string;
}

export type SkillResource = HumanCapabilitySkillResource | KnowledgeAreaSkillResource;

export type Skill = HumanCapabilitySkill | KnowledgeAreaSkill;

export interface SkillsFormData {
    skills: SkillBase[];
}
